import {
  THUMBNAIL_SIZE_MAX,
  THUMBNAIL_SIZE_MIN,
} from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/types';

type ThumbnailSizeSliderProps = {
  value: number;
  onChange: (value: number) => void;
};

export function ThumbnailSizeSlider({ value, onChange }: ThumbnailSizeSliderProps) {
  return (
    <input
      type="range"
      min={THUMBNAIL_SIZE_MIN}
      max={THUMBNAIL_SIZE_MAX}
      value={value}
      onChange={e => onChange(Number(e.target.value))}
      className="w-24 cursor-pointer accent-accent-active-primary-40"
    />
  );
}
